module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day02_10_stay-cd2fffe0fc30e6fa39d1e336a8136847.jpg";